<template>
    <div>
        <basic-input label="Subject" :options="options" :vertical="true" v-model="subject" @input="stringAnalysis" style="margin-bottom: 0 " />
        <!-- <basic-input label="Subject" :vertical="true" rule="required max:100" v-model="info.subject" ref="mailContentEditor" @emitChangeModel="onChangeModel"/> -->

        <div class="mb-3 flex-display">
            <div></div>
            <div class="font-weight-semibold ml-auto">
                <div class="text-right mt-2 mb-2">
                    <span class="font-weight-semibold">{{totalTextCharCnt}} character</span>
                </div>
                <div v-for="(message,index) in validationResult" :key="'codemirror'+index" class="text-right">
                    <span class="font-weight-semibold text-danger">{{message}}</span>
                </div>
            </div>
        </div>
        <legend v-if="paramSubjects.length > 0" class="text-uppercase font-size-sm font-weight-bold">Options</legend>
        <div class="form-group row mb-3" v-for="(param,index) in paramSubjects" :key="'smsSendModal_'+index">
            <div class="col-12">
                <div class="input-group">
                    <span class="input-group-prepend">
                        <span class="input-group-text">{{param.paramKey}}</span>
                    </span>
                    <input type="text" class="form-control" :key="'mailSendModal_'+index" @input="parametersTextChange" :data-value="param.value" :ref="'mailSendInput'+param.paramKey">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import {codemirror,CodeMirror} from 'vue-codemirror'
    // import 'codemirror/lib/codemirror.css'
    import subjectEditorMixin from "../../config/mixin/subjectEditorMixin";
    import CONST from '@/config/const/const';
    import BasicInput from "@/components/form/input/BasicInput"; 
    // CodeMirror.defineMode('customMailmode', () => {
    //     return {
    //         token(stream, state) {
    //             if (stream.match(CONST.REGEX.EDITOR)) {
    //                 return "style-param"
    //             } else {
    //                 stream.next()
    //                 return null
    //             }
    //         }
    //     }
    // })
    export default {
        name: "MailSubjectEditor",
        components: {
            BasicInput
        },
        mixins:[subjectEditorMixin],
        props: {
            rule: {
                type:String
            },
            value: {
                type:Object
            },
        },
        data() {
            return {
                // regex: /%([1-9]{1,1})%/g,
                // regex:/{{([1-9]{1,1})(\:)([S|A|T|D|H])(\:DDMMYYYY)?(\:MMHH24DDMMYYYY)?(\:MMHH24)?}}/g,
                regex:CONST.REGEX.STRING_ANALYSIS,
                paramSubjects:[],
                validationResult: [],
                subject:'',
                maxCharCount: 160,
                options: {
                    tabSize: 4,
                    mode: 'customMailmode',
                    theme: 'base16-dark',
                    lineNumbers: true,
                    line: true,
                    lineWrapping: true,
                    lineSeparator:'<br>'
                },
                parametersTextCount:0,
            }
        },
        computed: {
            plainTextCount: function() {
                return this.$filters.characterByte(this.subject.replace(this.regex,' '))
            },
            totalTextCharCnt: function() {
                return this.plainTextCount + this.parametersTextCount
            },
        },
        methods: {
            parametersTextChange: function(e) {
                this.parametersTextCount = this.paramSubjects.reduce((base,item)=> {
                    if(this.$refs['mailSendInput'+item.paramKey]) {
                        base += this.$refs['mailSendInput'+item.paramKey][0].value.length * item.duplParamCnt
                    }
                    return base
                },0)
            },
            validator: function() {
                this.validationResult = []
                if(this.isParamsDuplicated(this.paramSubjects.map(item=>item.paramKey))) this.validationResult.push('Parameter keys cannot be duplicated')
                if(this.paramSubjects.length > this.value.paramSubjectCnt) this.validationResult.push('The maximum number of parameters is '+this.value.paramSubjectCnt)
                if(this.totalTextCharCnt === 0) this.validationResult.push('This input is required.')
                if(this.totalTextCharCnt > 100) this.validationResult.push('Valid up to 100 characters.');
                return this.validationResult
            },
        },
        watch: {
            'totalTextCharCnt': function() {
                this.validator()
            },
            'value': function(val) {
                this.changeData(val)
            },
            'paramSubjects': function() {
                this.parametersTextCount = 0
            }
        }
    }
</script>

<style scoped>

</style>

